// services/customersApi.ts
import apiClient from "./apiClient";

export interface Customer {
  id: number;
  fullName: string;
  // email: string;
  phone: string;
  gstin: string | null;
  stateId: number;
  districtId: number;
  areaId: number;
  pincode: string;
  address: string;
  status: "active" | "inactive";
  organizationId: number;
  createdBy: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  State?: { id: number; name: string };
  District?: { id: number; name: string };
  Area?: { id: number; name: string };
  creator?: { id: number; ownerName: string };
}

export interface CreateCustomerPayload {
  fullName: string;
  // email: string;
  phone: string;
  stateId: number;
  districtId: number;
  areaName: string; // backend creates or reuses area by name
  pincode: string;
  address: string;
  // status: "active" | "inactive";
  gstin?: string;
}

export interface UpdateCustomerPayload {
  fullName?: string;
  // email?: string;
  phone?: string;
  gstin?: string;
  stateId?: number;
  districtId?: number;
  areaId?: number;
  pincode?: string;
  address?: string;
  status?: "active" | "inactive";
}

export interface CustomersResponse {
  customers: Customer[];
  pagination: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export const customersApi = {
  getAll: async (
    page: number,
    limit: number,
    search: string,
    areaId?: number,
  ): Promise<CustomersResponse> => {
    const response = await apiClient.get("/customers", {
      params: { page, limit, search: search.trim() || undefined, areaId },
    });
    return response.data;
  },
  getById: async (id: number): Promise<{ customer: Customer }> => {
    const response = await apiClient.get(`/customers/${id}`);
    return response.data;
  },
  create: async (
    data: CreateCustomerPayload,
  ): Promise<{ message: string; customer: Customer }> => {
    const response = await apiClient.post("/customers", data);
    return response.data;
  },
  update: async (
    id: number,
    data: UpdateCustomerPayload,
  ): Promise<{ message: string; customer: Customer }> => {
    const response = await apiClient.put(`/customers/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/customers/${id}`);
    return response.data;
  },
};
